<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        observaciones: "",
        fecha_productos: new Date(),
        state: true,
        id: 0,
      },
      detalleprodutos: [],
      title: "Compras",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compras",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }

    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    showDate2(date) {
      return moment(date).locale("es").format("MMM Do YYYY");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/reporte_pdf?departamento=" +
            this.$route.params.departamento +
            "&estante=" +
            this.$route.params.estante,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleprodutos = response.data.rows;
          console.log(response.data.rows);
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'productos' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Reporte -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body doc">
            <!-- Header corporativo -->
            <div class="doc-header">
              <div class="doc-brand">
                <img :src="logoUrl" alt="Logo" class="doc-logo" />
                <div>
                  <div class="doc-name">Repuestos Ariel GT</div>
                  <div class="doc-tag">Comapa, Jutiapa</div>
                </div>
              </div>
              <div class="doc-meta">
                <div class="doc-badge">PRODUCTOS POR DEPARTAMENTO</div>
                <div class="doc-date">Fecha: {{ this.showDate2(this.formPro.fecha_productos) }}</div>
              </div>
            </div>

            <div class="doc-section">Listado de productos</div>
            <table class="doc-table">
              <thead>
                <tr>
                  <th class="c" style="width: 45px">No.</th>
                  <th>Código</th>
                  <th>Producto y presentación</th>
                  <th class="c">Existencia</th>
                  <th class="r">P. compra</th>
                  <th class="r">P. venta</th>
                  <th>Proveedor</th>
                  <th>Ubicación</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleprodutos" v-bind:key="idx">
                  <td class="c">{{ idx + 1 }}</td>
                  <td>{{ item.Stock.codigo_stock }}</td>
                  <td>
                    {{ item.Stock.producto.nombre_producto }}
                    {{ item.Stock.presentacione.nombre_presentacion }}
                  </td>
                  <td class="c">{{ item.Stock.existencia_stock }}</td>
                  <td class="r">{{ money(item.Stock.precio_compra_stock) }}</td>
                  <td class="r">{{ money(item.Stock.precio_venta_stock) }}</td>
                  <td>{{ item.Stock.proveedore.company_proveedor }}</td>
                  <td v-if="item.departamento">
                    {{ item.departamento.nombre_departamento }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="doc-footer">Repuestos Ariel GT · Reporte de inventario</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.doc { color: #2b2f3a; font-size: 13px; }

.doc-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 18px;
}
.doc-brand { display: flex; align-items: center; gap: 16px; }
.doc-logo { height: 74px; width: auto; object-fit: contain; border-radius: 8px; }
.doc-name { font-size: 23px; font-weight: 800; color: #1b2a4e; }
.doc-tag { font-size: 12px; color: #6b7280; }
.doc-meta { text-align: right; }
.doc-badge {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 13px;
  padding: 6px 14px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.doc-date { font-size: 12px; color: #6b7280; margin-top: 6px; }

.doc-section {
  font-size: 14px; font-weight: 700; color: #1b2a4e;
  margin: 10px 0 8px; padding-left: 10px; border-left: 4px solid #c5a253;
}

.doc-table { width: 100%; border-collapse: collapse; }
.doc-table thead th {
  background: #1b2a4e; color: #fff; font-size: 10px; font-weight: 600;
  text-transform: uppercase; padding: 8px; text-align: left;
}
.doc-table tbody td { padding: 7px 8px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.doc-table tbody tr:nth-child(even) { background: #f9fafc; }
.doc-table .r { text-align: right; }
.doc-table .c { text-align: center; }

.doc-footer {
  margin-top: 26px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .doc, .doc * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
